import { Location } from "@models/location.model";
import { BaseConverter } from "./BaseConverter";
import { LocationDto } from "@dtos/location.dto";
import { AccomodationConverter } from "./accomodationConverter";

export class LocationConverter extends BaseConverter<Location, LocationDto>{
    private accConverter = new AccomodationConverter()

    modelToDto(model: Location): LocationDto {
        return new LocationDto(
            model.id,
            model.fullAddress,
            model.city,
            model.country,
            model.latitude,
            model.longitude,
            model.accomodation?this.accConverter.modelToDto(model.accomodation) : undefined 
        )
    }
    dtoToModel(dto: LocationDto): Location {
        return new Location(
            dto.id,
            dto.fullAddress,
            dto.city,
            dto.country,
            dto.latitude,
            dto.longitude,
            dto.accomodation?this.accConverter.dtoToModel(dto.accomodation) : undefined 
        )
    }
}